import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import renderOptions from './options-renderer';

const Select = ({
  className,
  containerClassName,
  fullWidth,
  hasEmptySelection,
  initialSelection,
  id,
  name,
  options,
  renderer = renderOptions,
  value,
  handleClick,
  ...rest
}) => {
  const containerClasses = cn(
    'c-select-container',
    {
      'c-select-container--block': fullWidth,
    },
    containerClassName
  );
  const classes = cn('c-select', className);

  const emptyOptionNode = hasEmptySelection && (
    <option value="" key="emptySelection">
      Select
    </option>
  );

  return (
    <div className={containerClasses}>
      <select
        className={classes}
        id={id}
        name={name}
        value={value}
        onChange={handleClick}
        {...rest}
      >
        {emptyOptionNode}
        {renderer(options, initialSelection)}
      </select>
    </div>
  );
};

export default Select;

Select.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  fullWidth: PropTypes.bool,
  hasEmptySelection: PropTypes.bool,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      optgroup: PropTypes.shape({
        className: PropTypes.string,
        label: PropTypes.string.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({})),
      }),
      renderer: PropTypes.func,
      text: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  renderer: PropTypes.func,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
  ]).isRequired,
};

Select.defaultProps = {
  className: '',
  containerClassName: '',
  fullWidth: false,
  hasEmptySelection: false,
  options: [],
};
